<template>
  <div class="dialog" v-if="this.load">
    <div class="left">
      <div class="detail_pic">
        <!-- <el-image :src="details.image">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image> -->
        <div class="img">
          <img src="../../assets/left.png" class="smallImg" v-show="details.previou_id" @click="getDetails(details.previou_id)" />
          <!-- <div class="three">
            <div id="DHList" class="imglist" :style="{
              width: imgList.length * 100 + '%',
            }">
              <img :src="$img + item" v-for="(item, index) in imgList" :key="index" />
            </div>
          </div> -->
          <div class="gif">
            <img :src="details.gif" alt="">
          </div>
          <img src="../../assets/right.png" class="smallImg" v-show="details.next_id" @click="getDetails(details.next_id)" />
        </div>
        <div @click="collect(details.is_collect)" class="collect">
          <i :class="[details.is_collect === 1 ? 'is_collect' : 'no_collect']" class="el-icon-star-on"></i>
        </div>
      </div>
      <div class="detail_msg">
        <div class="left">
          <div class="title">
            <img src="../../assets/02.jpg" alt="" />{{ details.title }}
          </div>
          <div class="size">
            <span>大小：{{ details.desc.size }}</span>
            <span>格式：{{ details.desc.format }}</span>
          </div>
          <div class="popular">
            <!-- 下载量 -->
            <span>
              <img height="35" width="35" src="../../assets/hot.png" alt="" />
              {{ details.down_no }}
            </span>
            <!-- 点赞量 -->
            <span>
              <img @click="resAssess(1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == -1" src="../../assets/suport.png" alt="" />
              <img @click="resAssess(0)" v-show="details.like_status == 1" height="35" width="35" src="../../assets/suport-active.png" alt="" />
              {{ details.like_no }}
            </span>
            <!-- 👎数量 -->
            <span>
              <img @click="resAssess(-1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == 1" src="../../assets/un_suport.png" alt="" />
              <img @click="resAssess(0)" height="35" width="35" v-show="details.like_status == -1" src="../../assets/un_suport-active.png" alt="" />
              {{ details.step_no }}
            </span>
          </div>
          <div class="other">
            <span>提示:数学产品不支持退货</span>
          </div>
          <div class="other">
            <span><i class="el-icon-warning-outline"></i>举报</span>
          </div>
        </div>
        <div class="right">
          <el-button v-if="!details.is_order" type="danger" @click="buySource">立即购买</el-button>
          <el-button v-else-if="!details.is_download" type="danger" @click="download">免费下载</el-button>
          <el-button v-else type="danger" @click="download">再次下载</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDetail,
  toggleCollect,
  buyResource,
  getList,
  getHotProduct,
  assess
} from '../../api/index'
export default {
  name: 'fontsDialog',
  data () {
    return {
      details: {},
      offset: 0,
      dataList: [],
      load: false,
      recommond_list: [
        require('../../assets/font.png'),
        require('../../assets/font.png'),
        require('../../assets/font.png'),
        require('../../assets/font.png')
      ],
      imgList: []
    }
  },
  props: {
    product_id: Number
  },
  methods: {
    // 获取详情
    getDetails (id) {
      getDetail({ product_id: id }, (res) => {
        this.details = res.result.data
        this.details.image = this.$imageUrl + res.result.data.image
        this.details.desc = JSON.parse(res.result.data.desc)
        this.$set(this.details, 'gif', this.$imageUrl + this.details.desc.image[0])
        const c = res.result.data.desc.character.join(',')
        this.details.desc.character = c
        const u = res.result.data.desc.use.join(',')
        this.details.desc.use = u
        this.load = true
        this.imgList = this.details.display_path
        this.$forceUpdate()

        // setTimeout(() => {
        //   document
        //     .getElementById('DHList')
        //     .style.setProperty('--step', this.imgList.length)
        // }, 0)
      })
    },
    // 收藏
    collect (isCollect) {
      if (!this.$store.state.user.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      toggleCollect(
        {
          product_id: this.details.product_id,
          collect: isCollect ^ 1,
          token: this.$store.state.user.token
        },
        (res) => {
          if (res.status === 'success') {
            this.details.is_collect = this.details.is_collect ^ 1
          }
        }
      )
    },
    // 购买
    buySource () {
      if (!this.$store.state.user.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      buyResource(
        { product_id: this.details.product_id, token: this.$store.state.user.token },
        (res) => {
          if (res.status === 'success') {
            this.details.is_order = 1
          }
        }
      )
    },
    download () {
      this.$emit('download', this.details)
    },
    getHot () {
      getHotProduct(
        {
          offset: 0,
          length: 4,
          type: 3
        },
        (res) => {
          this.recommond_list = res.result[0].data.splice(0, 4)
        }
      )
    },
    // 获取相似
    resGetList () {
      getList(
        {
          offset: this.offset,
          length: 3,
          type: 3
        },
        (res) => {
          this.dataList = res.result.data

          if (res.result.total > this.offset + 5) {
            this.offset += 5
          } else {
            this.offset = 0
          }
        }
      )
    },
    // 跳转详情页
    toDetail (id) {
      this.getDetails(id)
    },
    // 查看更多
    toMore () {
      this.$router.push({ path: '/modules' })
    },
    // 点赞
    resAssess (value) {
      assess(
        {
          product_id: this.details.product_id,
          value: value
        },
        (res) => {
          if (res.status == 'success') {
            this.details.like_status = res.result.data.data
            this.details.like_no = res.result.data.ass_no
            this.details.step_no = res.result.data.dept_no
          }
        }
      )
    }
  },
  created () {
    this.getDetails(this.product_id)
    // this.resGetList()
    // this.getHot()
  }
}
</script>

<style scoped lang="scss">
.dialog {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.left {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
}
.detail_pic {
  position: relative;
  width: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  .img {
    margin: 0 auto;
    padding: 30px 0 40px;
    width: 100%;
    // height: ;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    img {
      margin: 0 auto;
      display: block;
      // width: 864px;
      height: 1200px;
    }
    .gif {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .smallImg {
      width: 60px;
      height: 50px;
      padding: 20px;
      padding-right: 10px;
      border-radius: 50%;
      background-color: rgba(50, 50, 50, 0.5);
      cursor: pointer;
      position: absolute;
      top: 40%;
    }
    .smallImg:first-child {
      padding-left: 10px;
      padding-right: 20px;
      left: 30px;
    }
    .smallImg:last-child {
      right: 30px;
    }
  }
  .collect {
    z-index: 999;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
    font-size: 38px;
    border-radius: 50%;
    box-shadow: 0 0 9px 3px #ccc;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .is_collect {
      color: #f4ea2a;
    }
    .no_collect {
      color: #999;
    }
  }
  .pic_list {
    margin-top: 10px;
    display: flex;
    .el-image {
      width: 300px;
      height: 200px;
    }
  }
  .three {
    width: 100%;
    height: 960px;
    overflow: hidden;
    .imglist {
      --step: 0;

      width: 100%;
      height: 100%;
      animation: threeD 2s steps(var(--step)) infinite;
      display: flex;
    }
    @keyframes threeD {
      100% {
        transform: translateX(-100%);
      }
    }
    img {
      flex: 1;
      height: 100%;
    }
    .div {
      float: left;
      width: 880px;
      height: 100%;
      text-align: center;
      font-size: 30px;
      line-height: 510px;
      background: chartreuse;
    }
  }
}
.detail_msg {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 40px;
  display: flex;
  border-top: 1px solid #ccc;
  .left {
    margin-right: 100px;
  }
  .right {
    .el-button {
      font-size: 20px;
      margin-right: 20px;
      margin-top: 40px;
      border-radius: 6px;
      height: 60px;
      width: 300px;
    }
  }
  .title {
    font-size: 22px;
    color: #333;
    display: flex;
    align-items: center;
    img {
      width: 45px;
      height: 45px;
      margin-right: 10px;
    }
  }
  .size {
    height: 40px;
    display: flex;
    align-items: center;
    margin: 10px 0;
    span {
      margin-right: 30px;
      font-size: 18px;
      color: #999999;
    }
  }
  .base {
    margin-top: 20px;
    font-size: 18px;
    color: #000;
  }
  .popular {
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-size: 12px;
    color: #999;
    cursor: pointer;
    span {
      display: flex;
      align-items: center;
      margin-right: 30px;
      img {
        margin-right: 5px;
      }
      font-size: 18px;
    }
  }
  .popular2 {
    margin: 10px 0;
    font-size: 12px;
    color: #999;
  }
  .is_collect {
    color: red;
  }
  .no_collect {
    color: #999;
  }
  .character {
    margin-bottom: 20px;
    font-size: 12px;
    color: #666;
    span {
      margin: 0 5px;
    }
  }
  .other {
    margin: 15px 0;
    span {
      color: #999999;
      font-size: 16px;
      :first-child {
        margin-right: 5px;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }
}

.bottom {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
  .same {
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    margin-top: 20px;

    .same_top {
      display: flex;
      justify-content: space-between;
      color: #999;
      font-size: 16px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 20px;
      .i {
        cursor: pointer;
      }
    }
    .same_content {
      display: flex;
      :last-child {
        margin-right: 0;
      }
      .same_list {
        margin-top: 20px;
        cursor: pointer;
        box-shadow: 0 0 8px #eeeeee;
        img {
          width: 100%;
          height: 320px;
        }
        & > div {
          padding: 10px;
          .list_title {
            font-size: 16px;
            color: #666;
          }
          .list_introduce {
            margin-top: 5px;
            margin-bottom: 10px;
            font-size: 16px;
            color: #999;
          }
        }
      }
    }
    .same_content > div {
      width: 32%;
      margin-right: 2%;
    }
  }
}
</style>
